import { Context } from '@leverege/plugin';
import MoltenUtil from "../../MoltenUtil.js";
import SortModels from "./SortModels.js";
function create(delegateType, cxtOrObjectType) {
  const context = typeof cxtOrObjectType === 'object' ? cxtOrObjectType : {
    objectType: cxtOrObjectType
  };
  const {
    objectType
  } = context;
  const Model = SortModels.getSortModelFor(delegateType, objectType);
  let sortModel = Model?.create({
    objectType
  }) || null;
  const cfgs = MoltenUtil.sortedPlugins('SortModelConfigurer', Context.createMatch({
    ...context,
    delegateType
  }));
  cfgs.forEach(c => {
    try {
      const nConditionFilterModel = c.configure(sortModel, delegateType, context);
      sortModel = nConditionFilterModel || sortModel;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  });
  return sortModel;
}
export default {
  create
};